import { render, staticRenderFns } from "./recommended-people.vue?vue&type=template&id=db1987da&scoped=true&lang=pug&"
import script from "./recommended-people.vue?vue&type=script&lang=js&"
export * from "./recommended-people.vue?vue&type=script&lang=js&"
import style0 from "./recommended-people.vue?vue&type=style&index=0&id=db1987da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1987da",
  null
  
)

export default component.exports